import React from 'react'

import { EuiFlexGrid, EuiFlexGroup, EuiFlexItem, EuiIcon, EuiImage, EuiText } from '@elastic/eui'

import EntertainmentPNG from './images/Entertainment.png'
import FamilyFriendlyPNG from './images/Family Friendly.png'
import LifestylePNG from './images/Lifestyle.png'
import MajorPNG from './images/Major.png'
import NewsPNG from './images/News.png'
import SportsPNG from './images/Sports.png'

export interface PlannerTvLegendProps {
  colorMap: Record<string, string>
}

const categoryConfig = [
  { key: 'Major', label: 'Major Networks', logo: MajorPNG, logoMarginLeft: 20 },
  { key: 'Sports', label: 'Sports', logo: SportsPNG, logoMarginLeft: 16 },
  { key: 'News', label: 'News', logo: NewsPNG, logoMarginLeft: 12 },
  { key: 'Entertainment', label: 'Entertainment', logo: EntertainmentPNG, logoMarginLeft: 20 },
  { key: 'Family', label: 'Family Friendly', logo: FamilyFriendlyPNG, logoMarginLeft: 18 },
  { key: 'Lifestyle', label: 'Lifestyle', logo: LifestylePNG, logoMarginLeft: 12 }
]

export const PlannerTvLegend: React.FC<PlannerTvLegendProps> = ({ colorMap }) => {
  const iconMarginRight = 5
  const logoWidth = 150

  return (
    <EuiFlexGrid columns={3}>
      {categoryConfig.map(item => (
        <EuiFlexItem key={item.key}>
          <EuiFlexGroup direction='column' gutterSize='xs' alignItems='flexStart'>
            <EuiFlexItem grow={false}>
              <EuiFlexGroup gutterSize='none' alignItems='center'>
                <EuiFlexItem grow={false} style={{ width: 22, marginRight: iconMarginRight }}>
                  <div
                    style={{
                      width: 12,
                      height: 12,
                      borderRadius: '50%',
                      backgroundColor: colorMap[item.key],
                      flexShrink: 0,
                      margin: 5
                    }}
                  />
                </EuiFlexItem>
                <EuiFlexItem>
                  <EuiText size='m' style={{ marginTop: 2 }}>
                    <strong>{item.label}</strong>
                  </EuiText>
                </EuiFlexItem>
              </EuiFlexGroup>
            </EuiFlexItem>
            {item.logo && (
              <EuiFlexItem grow={false} style={{ marginTop: -5 }}>
                <EuiImage alt={item.label} src={item.logo} size='m' style={{ marginLeft: item.logoMarginLeft + iconMarginRight, width: logoWidth, objectFit: 'contain' }} />
              </EuiFlexItem>
            )}
          </EuiFlexGroup>
        </EuiFlexItem>
      ))}
    </EuiFlexGrid>
  )
}

export default PlannerTvLegend
